module.exports = __webpack_public_path__ + "static/img/IMG_20170906_194602.5bcc271a.jpg";